<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div v-if="lmodel !== null && vmodel !== null">
    <TabView class="setting-layout">
      <!-- Setting -->

      <TabPanel header="Settings">
        <div class="grid" style="align-items: center">
          <div class="col-12 lg:col-11 py-0">
            <span class="general-settings-text">
              {{ staticData.settings.imgbeforewidget }}
            </span>
          </div>
          <div class="col-12 lg:col-1 py-0">
            <label>
              <div class="toggle-button toggleblock-btn">
                <span
                  :class="{
                    'toggle-on': displayimgwidget,
                    'toggle-off': !displayimgwidget,
                  }"
                  @click="displayimgwidget = !displayimgwidget"
                ></span>
              </div>
            </label>
          </div>
        </div>

        <div class="grid" v-if="displayimgwidget">
          <div class="col-12">
            <div class="border-box">
              <PrimeButton
                label="Image archive"
                class="rwd-btn"
                @click="selectImgType('imgarchive')"
                :class="{ 'active-btn': selectedImgType === 'imgarchive' }"
                id="imgarchive"
              ></PrimeButton>

              <PrimeButton
                label="Image url"
                class="rwd-btn1"
                @click="selectImgType('imgurl')"
                :class="{ 'active-btn': selectedImgType === 'imgurl' }"
                id="imgurl"
              ></PrimeButton>
            </div>
          </div>
        </div>

        <!-- Mobile Side -->
        <div
          class="grid"
          v-if="
            selectedImgType === 'imgarchive' &&
            displayimgwidget &&
            selectedDeviceType == 'mobile'
          "
        >
          <div
            :class="
              vmodel1.ambCusHeadMobMinExpImglogoPath == null ||
              vmodel1.ambCusHeadMobMinExpImglogoPath === ''
                ? 'field col-12 photo-container1'
                : 'field col-12 photo-container'
            "
          >
            <div
              :class="
                vmodel1.ambCusHeadMobMinExpImglogoPath == null ||
                vmodel1.ambCusHeadMobMinExpImglogoPath === ''
                  ? 'photo-sectionimg cursor-pointer'
                  : 'photo-section cursor-pointer'
              "
            >
              <div v-if="!cropperIsActive">
                <img
                  v-if="
                    vmodel1.ambCusHeadMobMinExpImglogoPath !== '' &&
                    vmodel1.ambCusHeadMobMinExpImglogoPath !== null
                  "
                  :src="vmodel1.ambCusHeadMobMinExpImglogoPath"
                  alt
                  class="imagefit"
                />
              </div>
              <FileUpload
                type="file"
                id="fileidmobileexp"
                ref="filemobileexp"
                accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff"
                @select="handleFileUploadExpandMob($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />
              <div
                v-if="
                  !cropperIsActive &&
                  (vmodel1.ambCusHeadMobMinExpImgactualFileName == null ||
                    vmodel1.ambCusHeadMobMinExpImgactualFileName == '')
                "
                class="upload-icon"
              ></div>
              <span
                v-if="
                  !cropperIsActive &&
                  (vmodel1.ambCusHeadMobMinExpImgactualFileName == null ||
                    vmodel1.ambCusHeadMobMinExpImgactualFileName == '')
                "
                >{{ staticData.settings.dropImg }}</span
              >
              <PrimeButton
                v-if="
                  !cropperIsActive &&
                  (vmodel1.ambCusHeadMobMinExpImgactualFileName == null ||
                    vmodel1.ambCusHeadMobMinExpImgactualFileName == '')
                "
                label="Browse"
                class="browse-btn"
                icon="pi pi-folder-open"
                @click="openFileUploadMobileExp"
              />
              <div class="mb-2">
                <PrimeButton
                  v-if="
                    !cropperIsActive &&
                    vmodel1.ambCusHeadMobMinExpImgactualFileName !== null &&
                    vmodel1.ambCusHeadMobMinExpImgactualFileName !== ''
                  "
                  label="Replace"
                  class="replace-button"
                  @click="replaceFileMobileExp"
                  icon="fa fa-undo"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActive &&
                    vmodel1.ambCusHeadMobMinExpImgactualFileName !== null &&
                    vmodel1.ambCusHeadMobMinExpImgactualFileName !== ''
                  "
                  label="Clear"
                  class="clear-button ml-2"
                  @click="clearImageMobileExp"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActive &&
                    vmodel1.ambCusHeadMobMinExpImgactualFileName !== null &&
                    vmodel1.ambCusHeadMobMinExpImgactualFileName !== ''
                  "
                  label="Crop"
                  class="crop-button ml-2"
                  @click="activateCropper"
                  icon="fa fa-crop"
                />
                <cropper
                  v-if="cropperIsActive"
                  class="imagefit"
                  :src="vmodel1.ambCusHeadMobMinExpImglogoPath"
                  :auto-zoom="true"
                  ref="cropperComponent3"
                />
              </div>
              <div class="mt-3 mb-2">
                <PrimeButton
                  v-if="cropperIsActive"
                  label="Clear"
                  class="clear-button mt-2"
                  @click="closeCropper"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="cropperIsActive"
                  label="Submit"
                  class="submit-button mt-2 ml-2"
                  @click="captureCroppedImage"
                  icon="fa fa-check"
                />
              </div>
              <FileUpload
                ref="photo"
                name="photo"
                accept=".png, .jpg, .jpeg, .gif"
                @select="onAdvancedUpload($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />
            </div>
          </div>
        </div>
        <!-- Desktop Side -->

        <div
          class="grid"
          v-if="
            selectedImgType === 'imgarchive' &&
            displayimgwidget &&
            selectedDeviceType == 'desktop'
          "
        >
          <div
            :class="
              vmodel1.ambCusHeadDeskMinExpImglogoPath == null ||
              vmodel1.ambCusHeadDeskMinExpImglogoPath === ''
                ? 'field col-12 photo-container1'
                : 'field col-12 photo-container'
            "
          >
            <div
              :class="
                vmodel1.ambCusHeadDeskMinExpImglogoPath == null ||
                vmodel1.ambCusHeadDeskMinExpImglogoPath === ''
                  ? 'photo-sectionimg cursor-pointer'
                  : 'photo-section cursor-pointer'
              "
            >
              <div v-if="!cropperIsActiveMinDesk">
                <img
                  v-if="
                    vmodel1.ambCusHeadDeskMinExpImglogoPath !== '' &&
                    vmodel1.ambCusHeadDeskMinExpImglogoPath !== null
                  "
                  :src="vmodel1.ambCusHeadDeskMinExpImglogoPath"
                  alt
                  class="imagefit"
                />
              </div>
              <FileUpload
                type="file"
                id="fileiddesktopexp"
                ref="filedesktopexp"
                accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff"
                @select="handleFileUploadDesktopExp($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
              />
              <div
                v-if="
                  !cropperIsActiveMinDesk &&
                  (vmodel1.ambCusHeadDeskMinExpImgactualFileName == null ||
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName == '')
                "
                class="upload-icon"
              ></div>
              <span
                v-if="
                  !cropperIsActiveMinDesk &&
                  (vmodel1.ambCusHeadDeskMinExpImgactualFileName == null ||
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName == '')
                "
                >{{ staticData.settings.dropImg }}</span
              >
              <PrimeButton
                v-if="
                  !cropperIsActiveMinDesk &&
                  (vmodel1.ambCusHeadDeskMinExpImgactualFileName == null ||
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName == '')
                "
                label="Browse"
                class="browse-btn"
                icon="pi pi-folder-open"
                @click="openFileUploadDesktopExp"
              />
              <div class="mt-2">
                <PrimeButton
                  v-if="
                    !cropperIsActiveMinDesk &&
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName !== null &&
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName !== ''
                  "
                  label="Replace"
                  class="replace-button"
                  @click="replaceFileDesktopExp"
                  icon="fa fa-undo"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMinDesk &&
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName !== null &&
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName !== ''
                  "
                  label="Clear"
                  class="clear-button ml-2"
                  @click="clearImageDesktopExp"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="
                    !cropperIsActiveMinDesk &&
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName !== null &&
                    vmodel1.ambCusHeadDeskMinExpImgactualFileName !== ''
                  "
                  label="Crop"
                  class="crop-button ml-2"
                  @click="cropImageDesktopExp"
                  icon="fa fa-crop"
                />

                <cropper
                  v-if="cropperIsActiveMinDesk"
                  class="imagefit"
                  :src="vmodel1.ambCusHeadDeskMinExpImglogoPath"
                  :auto-zoom="true"
                  ref="cropperComponent4"
                />
              </div>
              <div class="mt-3 mb-2">
                <PrimeButton
                  v-if="cropperIsActiveMinDesk"
                  label="Clear"
                  class="clear-button mt-2"
                  @click="closeCropperMinDesk"
                  icon="fa fa-refresh"
                />
                <PrimeButton
                  v-if="cropperIsActiveMinDesk"
                  label="Submit"
                  class="submit-button mt-2 ml-2"
                  @click="captureCroppedImageMinDesk"
                  icon="fa fa-check"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="grid" v-if="imgurl && displayimgwidget">
          <div class="col-12 lg:col-12">
            <label
              for="minwidOffsetDesktopHor"
              class="control-label"
              :isRequiredLabel="false"
              >{{ staticData.settings.img_url_title }}</label
            >
            <InputText
              v-model="imgurlval"
              id="minwidOffsetDesktopHor"
              class="mt-1"
            ></InputText>
          </div>
        </div>

        <div class="grid col-12 mt-2">
          <span class="general-settings-text">
            {{ staticData.settings.widget_type }}
          </span>
        </div>

        <div class="grid">
          <div class="col-12">
            <div class="border-box">
              <PrimeButton
                label="Text"
                class="rwd-btn"
                @click="selectWidgetType('text')"
                :class="{ 'active-btn': selectedWidgetType === 'text' }"
                id="text"
              ></PrimeButton>

              <PrimeButton
                label="Image"
                class="rwd-btn1"
                @click="selectWidgetType('image')"
                :class="{ 'active-btn': selectedWidgetType === 'image' }"
                id="img"
              ></PrimeButton>
            </div>
          </div>
        </div>

        <div class="grid" v-if="selectedWidgetType === 'text'">
          <div class="col-12 lg:col-12" v-if="selectedDeviceType == 'desktop'">
            <label
              for="ambPopupMinimizeTitleDesktop"
              class="control-label"
              :isRequiredLabel="false"
              >{{ lmodel.ambPopupMinimizeTitle }}</label
            >
            <InputText
              id="CustomerPopupMinimizeTitle"
              type="text"
              class="mt-1"
              autocomplete="off"
              v-model="vmodel1.ambCustomerPopupMinimizeTitle"
              :placeholder="lmodel.ambPopupMinimizeTitlePlaceholder"
            ></InputText>
          </div>
          <div
            class="col-12 lg:col-12 py-0"
            v-if="selectedDeviceType == 'desktop'"
          >
            <label
              for="ambPopupMinimizeCodeDeliveryTitle"
              class="control-label"
              :isRequiredLabel="false"
              >{{ lmodel.ambPopupMinimizeCodeDeliveryTitle }}</label
            >
            <InputText
              id="CustomerPopupMinimizeCodeDelivery"
              type="text"
              autocomplete="off"
              v-model="vmodel1.ambCustomerPopupMinTabCodeDel"
              :placeholder="lmodel.ambPopupMinimizeCodeDeliveryPlaceholder"
              class="mt-1"
            ></InputText>
          </div>
          <div class="col-12 lg:col-12" v-if="selectedDeviceType == 'mobile'">
            <label
              for="popupMinimizeTitleMobile"
              class="control-label"
              :isRequiredLabel="false"
              >{{ lmodel.ambPopupMinimizeTitleMobile }}</label
            >
            <Textarea
              id="CustomerPopupMinimizeTitleMobile"
              type="text"
              v-model="vmodel1.ambCustomerPopupMinimizeTitleMobile"
              autocomplete="off"
              :placeholder="lmodel.ambPopupMinimizeTitleMobilePlaceholder"
            ></Textarea>
          </div>

          <div
            class="col-12 lg:col-12 py-0"
            v-if="selectedDeviceType == 'mobile'"
          >
            <label
              :v-tooltip="lmodel.ambPopupMinimizeCodeDeliveryMobileToolTip"
              for="ambPopupMinimizeCodeDeliveryMobile-tooltip"
              class="control-label"
              >{{ lmodel.ambPopupMinimizeCodeDeliveryTitleMobile }}</label
            >
            <Textarea
              id="CustomerPopupMinimizeCodeDeliveryMobile"
              type="text"
              autocomplete="off"
              v-model="vmodel1.ambCustomerPopupMinTabCodeDelMobile"
              :placeholder="
                lmodel.ambPopupMinimizeCodeDeliveryMobilePlaceholder
              "
              class="mt-1"
            ></Textarea>
          </div>
        </div>

        <!-- If Image -->
        <div class="grid" v-show="isImg">
          <div
            class="grid col-12 lg:col-12 py-0 mt-1"
            style="text-align: center"
            v-if="selectedDeviceType == 'mobile'"
          >
            <!-- <label
              v-tooltip="lmodel.ambMobileMinWidImageToolTip"
              for="ambMobileMinWidImage-tooltip"
              class="control-label"
              :isRequiredLabel="false"
              >{{ lmodel.ambMobileMinWidImage }}</label
            >-->
            <div
              :class="
                vmodel1.mobMinWidimgPath === null ||
                vmodel1.mobMinWidimgPath === ''
                  ? 'field col-12 photo-container1'
                  : 'field col-12 photo-container'
              "
            >
              <div
                :class="
                  vmodel1.mobMinWidimgPath === null ||
                  vmodel1.mobMinWidimgPath === ''
                    ? 'photo-sectionimg cursor-pointer'
                    : 'photo-section cursor-pointer'
                "
              >
                <div v-if="!cropperIsActiveMinWidMob">
                  <img
                    v-if="
                      vmodel1.mobMinWidimgPath !== '' &&
                      vmodel1.mobMinWidimgPath !== null
                    "
                    :src="vmodel1.mobMinWidimgPath"
                    alt
                    class="imagefit"
                  />
                </div>
                <FileUpload
                  type="file"
                  id="fileImgminMob"
                  ref="fileImgminMob"
                  accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff"
                  @select="handleImgminMob($event)"
                  v-show="false"
                  :aria-describedby="`photo-help`"
                />

                <div
                  v-if="
                    !cropperIsActiveMinWidMob &&
                    (vmodel1.mobMinWidimgPath == null ||
                      vmodel1.mobMinWidimgPath == '')
                  "
                  class="upload-icon"
                ></div>
                <span
                  v-if="
                    !cropperIsActiveMinWidMob &&
                    (vmodel1.mobMinWidimgPath == null ||
                      vmodel1.mobMinWidimgPath == '')
                  "
                  >{{ staticData.settings.dropImg }}</span
                >

                <PrimeButton
                  v-if="
                    !cropperIsActiveMinWidMob &&
                    (vmodel1.mobMinWidimgname == null ||
                      vmodel1.mobMinWidimgname == '')
                  "
                  label="Browse"
                  class="browse-btn"
                  icon="pi pi-folder-open"
                  @click="openFileUploadImgminMob"
                />
                <div class="mt-2">
                  <PrimeButton
                    v-if="
                      !cropperIsActiveMinWidMob &&
                      vmodel1.mobMinWidimgname !== null &&
                      vmodel1.mobMinWidimgname !== ''
                    "
                    label="Replace"
                    class="replace-button"
                    @click="replaceFileImgminMob"
                    icon="fa fa-undo"
                  />
                  <PrimeButton
                    v-if="
                      !cropperIsActiveMinWidMob &&
                      vmodel1.mobMinWidimgname !== null &&
                      vmodel1.mobMinWidimgname !== ''
                    "
                    label="Clear"
                    class="clear-button ml-2"
                    @click="clearImageimgminMob()"
                    icon="fa fa-refresh"
                  />
                  <PrimeButton
                    v-if="
                      !cropperIsActiveMinWidMob &&
                      vmodel1.mobMinWidimgname !== null &&
                      vmodel1.mobMinWidimgname !== ''
                    "
                    label="Crop"
                    class="crop-button ml-2"
                    @click="cropImageimgminMob()"
                    icon="fa fa-crop"
                  />
                  <cropper
                    v-if="cropperIsActiveMinWidMob"
                    class="imagefit"
                    :src="vmodel1.mobMinWidimgPath"
                    :auto-zoom="true"
                    ref="cropperComponent5"
                  />
                </div>
                <div class="mt-3 mb-2">
                  <PrimeButton
                    v-if="cropperIsActiveMinWidMob"
                    label="Clear"
                    class="clear-button mt-2"
                    @click="closeCropperMinWidMob"
                    icon="fa fa-refresh"
                  />
                  <PrimeButton
                    v-if="cropperIsActiveMinWidMob"
                    label="Submit"
                    class="submit-button mt-2 ml-2"
                    @click="captureCroppedImageMinWidMob"
                    icon="fa fa-check"
                  />
                </div>
                <!-- <FileUpload
                ref="photo"
                name="photo"
                accept=".png, .jpg,.jpeg,.gif"
                @select="onAdvancedUpload($event)"
                v-show="false"
                :aria-describedby="`photo-help`"
                />-->
              </div>
            </div>
          </div>

          <div
            class="grid col-12 lg:col-12 py-0 mt-1"
            v-if="selectedDeviceType == 'desktop'"
          >
            <!-- <label
              v-tooltip="lmodel.ambDesktopMinWidImageToolTip"
              for="ambDesktopMinWidImage-tooltip"
              class="control-label"
              :isRequiredLabel="false"
            >{{ lmodel.ambDesktopMinWidImage }}</label>-->

            <div
              :class="
                vmodel1.deskMinWidimgPath === null ||
                vmodel1.deskMinWidimgPath === ''
                  ? 'field col-12 photo-container1'
                  : 'field col-12 photo-container'
              "
            >
              <div
                :class="
                  vmodel1.deskMinWidimgPath === null ||
                  vmodel1.deskMinWidimgPath === ''
                    ? 'photo-sectionimg cursor-pointer'
                    : 'photo-section cursor-pointer'
                "
              >
                <div v-if="!cropperIsActiveMinWidDesk">
                  <img
                    v-if="
                      vmodel1.deskMinWidimgPath !== '' &&
                      vmodel1.deskMinWidimgPath !== null
                    "
                    :src="vmodel1.deskMinWidimgPath"
                    alt
                    class="imagefit"
                  />
                </div>
                <FileUpload
                  type="file"
                  id="fileImgminDesk"
                  ref="fileImgminDesk"
                  accept=".jpeg, .jpg, .gif, .png, .bmp, .tiff"
                  @select="handleImgminDesktop($event)"
                  v-show="false"
                  :aria-describedby="`photo-help`"
                />
                <div
                  v-if="
                    !cropperIsActiveMinWidDesk &&
                    (vmodel1.deskMinWidimgPath == null ||
                      vmodel1.deskMinWidimgPath == '')
                  "
                  class="upload-icon"
                ></div>
                <span
                  v-if="
                    !cropperIsActiveMinWidDesk &&
                    (vmodel1.deskMinWidimgPath == null ||
                      vmodel1.deskMinWidimgname == '')
                  "
                  >{{ staticData.settings.dropImg }}</span
                >
                <PrimeButton
                  v-if="
                    !cropperIsActiveMinWidDesk &&
                    (vmodel1.deskMinWidimgname == null ||
                      vmodel1.deskMinWidimgname == '')
                  "
                  label="Browse"
                  class="browse-btn"
                  icon="pi pi-folder-open"
                  @click="openFileUploadImgminDesk"
                />
                <div class="mt-2">
                  <PrimeButton
                    v-if="
                      !cropperIsActiveMinWidDesk &&
                      vmodel1.deskMinWidimgname !== null &&
                      vmodel1.deskMinWidimgname !== ''
                    "
                    label="Replace"
                    class="replace-button"
                    @click="replaceFileImgminDesk"
                    icon="fa fa-undo"
                  />
                  <PrimeButton
                    v-if="
                      !cropperIsActiveMinWidDesk &&
                      vmodel1.deskMinWidimgname !== null &&
                      vmodel1.deskMinWidimgname !== ''
                    "
                    label="Clear"
                    class="clear-button ml-2"
                    @click="clearImageimgminDesk()"
                    icon="fa fa-refresh"
                  />
                  <PrimeButton
                    v-if="
                      !cropperIsActiveMinWidDesk &&
                      vmodel1.deskMinWidimgname !== null &&
                      vmodel1.deskMinWidimgname !== ''
                    "
                    label="Crop"
                    class="crop-button ml-2"
                    @click="cropImageimgminDesk()"
                    icon="fa fa-crop"
                  />

                  <cropper
                    v-if="cropperIsActiveMinWidDesk"
                    class="imagefit"
                    :src="vmodel1.deskMinWidimgPath"
                    :auto-zoom="true"
                    ref="cropperComponent6"
                  />
                </div>
                <div class="mt-3 mb-2">
                  <PrimeButton
                    v-if="cropperIsActiveMinWidDesk"
                    label="Clear"
                    class="clear-button mt-2"
                    @click="closeCropperMinWidDesk"
                    icon="fa fa-refresh"
                  />
                  <PrimeButton
                    v-if="cropperIsActiveMinWidDesk"
                    label="Submit"
                    class="submit-button mt-2 ml-2"
                    @click="captureCroppedImageMinWidDesk"
                    icon="fa fa-check"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid col-12 mt-2">
          <span class="general-settings-text">
            {{ staticData.settings.widget_display }}
          </span>
        </div>

        <div class="grid mt-1">
          <div class="col-12 py-0">
            <div class="border-box">
              <PrimeButton
                label="Float over content"
                class="rwd-btn"
                @click="selectWidgetDisplay('floatcontent')"
                :class="{ 'active-btn': widgetSelected === 'floatcontent' }"
                id="floatcontent"
              ></PrimeButton>

              <PrimeButton
                label="Embed on page"
                class="rwd-btn1"
                @click="selectWidgetDisplay('embpage')"
                :class="{ 'active-btn': widgetSelected === 'embpage' }"
                id="embpage"
              ></PrimeButton>
            </div>
          </div>
        </div>

        <div
          :class="
            isFloat && selectedDeviceType === 'desktop'
              ? 'grid container-spacing'
              : 'grid'
          "
          v-if="isFloat && selectedDeviceType === 'desktop'"
        >
          <div class="col-12">
            <label
              for="ambMobilePopupMinimizePosition"
              v-tooltip.top="lmodel.ambMobilePopupMinimizePositionToolTip"
              class="control-label"
              >{{ lmodel.ambPopupMinimizePosition }}</label
            >
            <DropDownRequire
              v-if="selectedDeviceType == 'desktop'"
              :validation="valmodel.customerPopupMinimizePosition"
              v-model="vmodel1.customerPopupMinimizePosition"
              :options="dmodel.ambassadorFriend.popupMinimizePositionListItems"
              PropName="Customer Popup Minimize Position"
              id="CustomerPopupMinimizePosition"
              :placeholder="lmodel.ambPopupMinimizePositionPlaceholder"
              class="mt-2"
              optionLabel="text"
              optionValue="value"
              editable
            ></DropDownRequire>
          </div>
        </div>
        <div
          :class="
            isFloat && selectedDeviceType === 'mobile'
              ? 'grid container-spacing'
              : 'grid'
          "
          v-if="isFloat && selectedDeviceType === 'mobile'"
        >
          <div class="col-12 py-0">
            <label
              for="ambMobilePopupMinimizePosition"
              v-tooltip.top="lmodel.ambMobilePopupMinimizePositionToolTip"
              class="control-label"
              >{{ lmodel.ambMobilePopupMinimizePosition }}</label
            >
            <DropDownRequire
              :validation="valmodel.customerPopupMinimizePosition"
              v-model="vmodel1.customerPopupMinimizePosition"
              :options="dmodel.ambassadorFriend.popupMinimizePositionListItems"
              PropName="Customer Popup Minimize Position"
              id="CustomerPopupMinimizePosition"
              :placeholder="lmodel.ambPopupMinimizePositionPlaceholder"
              class="mt-2"
              optionLabel="text"
              optionValue="value"
              editable
            ></DropDownRequire>
          </div>
        </div>

        <!-- <div
          :class="
            isFloat && selectedDeviceType === 'mobile'
              ? 'grid container-spacing'
              : 'grid'
          "
          v-if="
            widgetSelected === 'floatcontent' && selectedDeviceType === 'mobile'
          "
        >
          <div class="col-12">
            <label
              for="ambMobilePopupMinimizePosition"
              v-tooltip.top="lmodel.ambMobilePopupMinimizePositionToolTip"
              class="control-label pt-0"
              >{{ lmodel.ambMobilePopupMinimizePosition }}</label
            >
            <DropDownRequire
              v-model="vmodel1.mobileMinimizePosition"
              :options="dmodel.ambassadorFriend.popupMinimizePositionListItems"
              id="mobileMinimizePosition"
              class="mt-1"
              optionLabel="text"
              optionValue="value"
              editable
            ></DropDownRequire>
          </div>
        </div> -->

        <div
          :class="
            selectedDeviceType === 'desktop' && isFloat
              ? 'grid container-spacing'
              : 'grid'
          "
          v-if="selectedDeviceType === 'desktop' && isFloat"
        >
          <div class="col-12 py-0">
            <h5 class="my-0">
              <small>{{ lmodel.setMinWidOffsetDesktop }}</small>
            </h5>
          </div>

          <div class="col-12 lg:col-6 py-0">
            <label-tooltip
              :labelvalue="lmodel.setMinwidOffsetDesktopHor"
              :tooltipvalue="lmodel.setMinwidOffsetDesktopHorToolTip"
              tooltipvalueFor="minwidOffsetDesktopHor-tooltip"
              labelclass="control-label"
              :isRequiredLabel="false"
            ></label-tooltip>
            <InputRequiredNumber
              v-model="vmodel1.minwidOffsetDesktopHor"
              id="minwidOffsetDesktopHor"
              class="mt-1"
              :placeholder="lmodel.setMinwidOffsetDesktopHorPlaceholder"
            ></InputRequiredNumber>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label-tooltip
              :labelvalue="lmodel.setMinwidOffsetDesktopVer"
              :tooltipvalue="lmodel.setMinwidOffsetDesktopVerToolTip"
              tooltipvalueFor="minwidOffsetDesktopVer-tooltip"
              labelclass="control-label"
              :isRequiredLabel="false"
            ></label-tooltip>
            <InputRequiredNumber
              v-model="vmodel1.minwidOffsetDesktopVer"
              id="minwidOffsetDesktopVer"
              class="mt-1"
              :placeholder="lmodel.setMinwidOffsetDesktopVerPlaceholder"
            ></InputRequiredNumber>
          </div>
        </div>

        <div
          :class="
            isFloat && selectedDeviceType == 'mobile'
              ? 'grid container-spacing'
              : 'grid'
          "
          v-if="isFloat && selectedDeviceType == 'mobile'"
        >
          <div class="col-12 py-0">
            <h5 class="my-0">
              <small>{{ lmodel.setMinWidOffsetMobile }}</small>
            </h5>
          </div>
          <div class="col-12 lg:col-6 py-0">
            <label
              :v-tooltip="lmodel.setMinwidOffsetMobileHorToolTip"
              for="minwidOffsetMobileHor-tooltip"
              class="control-label"
              :isRequiredLabel="false"
              >{{ lmodel.setMinwidOffsetMobileHor }}</label
            >
            <InputRequiredNumber
              v-model="vmodel1.minwidOffsetMobileHor"
              id="minwidOffsetMobileHor"
              class="mt-1"
              :placeholder="lmodel.setMinwidOffsetMobileHorPlaceholder"
            ></InputRequiredNumber>
          </div>

          <div class="col-12 lg:col-6 py-0">
            <label
              :v-tooltip="lmodel.setMinwidOffsetMobileVerToolTip"
              for="minwidOffsetMobileVer-tooltip"
              class="control-label"
              :isRequiredLabel="false"
              >{{ lmodel.setMinwidOffsetMobileVer }}</label
            >
            <InputRequiredNumber
              v-model="vmodel1.minwidOffsetMobileVer"
              id="minwidOffsetMobileVer"
              class="mt-1"
              :placeholder="lmodel.setMinwidOffsetMobileVerPlaceholder"
            ></InputRequiredNumber>
          </div>
        </div>

        <div
          :class="
            (selectedDeviceType === 'desktop' ||
              selectedDeviceType === 'mobile') &&
            isEmb
              ? 'grid container-spacing'
              : 'grid'
          "
          v-if="isEmb"
        >
          <div class="col-12 lg:col-12 py-0">
            <label
              class="control-label"
              for="minWidFontName-tooltip"
              :isRequiredLabel="true"
              >{{ staticData.settings.css_data }}</label
            >
            <InputText
              v-model="vmodel1.ambCssSelector"
              id="minWidCustFontName"
              autocomplete="off"
              @input="validateCssInput"
              class="mt-1"
            />
            <div v-if="!isValidCss" class="text-red-500">
              {{ staticData.settings.css_validate }}
            </div>
          </div>
        </div>

        <div class="grid container-spacing">
          <div class="col-12 lg:col-11 py-0">
            <span class="general-settings-text">{{
              staticData.settings.cnt_timer
            }}</span>
          </div>
          <div class="col-12 lg:col-1 py-0">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambcntdwn"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': counttimer,
                    'toggle-off': !counttimer,
                  }"
                  @click="counttimer = !counttimer"
                ></span> -->
            </div>
          </div>
        </div>
        <div class="grid mb-2">
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambcntdwn">
            <label
              v-tooltip="lmodel.ambExpireTextToolTip"
              for="expireText-tooltip"
              class="control-label"
              :isRequiredLabel="false"
              >{{ lmodel.ambExpireText }}</label
            >
            <InputRequiredText
              v-model="vmodel1.ambExpireText"
              type="text"
              id="ExpireText"
              class="expire-text"
            ></InputRequiredText>
          </div>
          <div class="col-12 lg:col-6 py-0" v-if="vmodel1.ambcntdwn"></div>
        </div>
        <div class="grid container-spacing">
          <div class="col-12 lg:col-11 py-0">
            <span class="general-settings-text">{{
              staticData.settings.shake_animation
            }}</span>
          </div>
          <div class="col-12 lg:col-1 py-0">
            <div class="toggle-button toggleblock-btn">
              <ToggleButton
                v-model="vmodel1.ambshake"
                onIcon="toggle-on"
                offIcon="toggle-off"
                class="toggle-btn"
              />
              <!-- <span
                  :class="{
                    'toggle-on': shakeanimation,
                    'toggle-off': !shakeanimation,
                  }"
                  @click="shakeanimation = !shakeanimation"
                ></span> -->
            </div>
          </div>
        </div>
      </TabPanel>

      <!-- Styling  -->
      <TabPanel header="Styling" v-if="lmodel !== null && vmodel !== null">
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">
              {{ lmodel.setMinimizedWidgetPadding }}
            </span>
          </div>
        </div>
        <div class="grid">
          <div class="col-6 p-inputgroup">
            <span class="p-inputgroup-add">
              <i class="left-right-icon"></i>
            </span>
            <InputText
              id="SiteId"
              :class="{
                'p-invalid': !valmodel.minwidpadMobileB,
              }"
              v-model="vmodel1.setMinwidpadMobileB"
              class="input-border"
              editable
            ></InputText>
          </div>
          <div class="col-5 p-inputgroup">
            <span class="p-inputgroup-add">
              <i class="top-bottom-icon"></i>
            </span>
            <InputText
              id="SiteId"
              :class="{
                'p-invalid': !valmodel.minwidpadMobileL,
              }"
              v-model="vmodel1.setMinwidpadMobileL"
              class="input-border"
              editable
            ></InputText>
          </div>
          <div class="col-1">
            <span class="p-inputgroup-addon float">
              <i class="group-icon"></i>
            </span>
          </div>
        </div>
        <div class="grid col-12">
          <div
            v-if="
              valmodel.minwidpadMobileB.$invalid &&
              valmodel.minwidpadMobileB.$dirty
            "
            class="col-6 lg:col-6 p-error"
          >
            <span>Minimum value allowed is 0,Maximum value allowed is 999</span>
          </div>
          <div class="col-5 lg:col-5"></div>
          <div v-if="valmodel.minwidpadMobileL.$invalid" class="col-5 p-error">
            <span>Minimum value allowed is 0,Maximum value allowed is 999</span>
          </div>
        </div>

        <div class="grid">
          <div class="col-11 lg:col-11">
            <div style="display: flex">
              <div class="p-inputgroup">
                <span class="p-inputgroup-add">
                  <i class="radius-icon"></i>
                </span>
                <InputText
                  id="SiteId"
                  v-model="valuepx"
                  class="input-border border-icon"
                  editable
                ></InputText>
              </div>
              <button class="hrs-btn">{{ staticData.styling.buttonpx }}</button>
              <div>
                <button @click="increaseValuePx" class="up-btn">
                  <i class="pi pi-chevron-up ar-color"></i>
                </button>
                <button @click="decreaseValuePx" class="down-btn">
                  <i class="pi pi-chevron-down ar-color"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-1">
            <span class="p-inputgroup-addon float" @click="toggleInputs">
              <i class="subtract-icon"></i>
            </span>
          </div>
        </div>
        <div class="grid">
          <div class="col-6 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-icon"></i>
            </span>
            <InputText
              id="SiteId"
              placeholder="0"
              class="input-border"
              editable
            ></InputText>
          </div>
          <div class="col-5 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-right-icon"></i>
            </span>
            <InputText
              id="SiteId"
              placeholder="0"
              class="input-border"
              editable
            ></InputText>
          </div>
          <div class="col-1" v-show="showInputs">
            <span class="p-inputgroup-addon-radius float">
              <i class="subtractclick-icon"></i>
            </span>
          </div>
          <div class="col-6 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-left-bottom-icon"></i>
            </span>
            <InputText
              id="SiteId"
              class="input-border"
              placeholder="0"
              editable
            ></InputText>
          </div>
          <div class="col-5 p-inputgroup" v-show="showInputs">
            <span class="p-inputgroup-add">
              <i class="radius-right-bottom-icon"></i>
            </span>
            <InputText
              id="SiteId"
              placeholder="0"
              class="input-border"
              editable
            ></InputText>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12 mt-2">
            <span class="general-settings-text">
              {{ staticData.styling.text }}
            </span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <DropDownRequire
              :options="TextOptions"
              id="SiteId"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              editable
              v-model="selectedOptionText"
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid">
          <div class="col-6 lg:col-6">
            <div style="display: flex">
              <div class="p-inputgroup">
                <span class="p-inputgroup-add">
                  <i class="value-icon"></i>
                </span>
                <InputText
                  id="SiteId"
                  v-model="value"
                  class="input-border border-icon"
                  editable
                ></InputText>
              </div>
              <div>
                <button @click="increaseValue" class="up-btn">
                  <i class="pi pi-chevron-up ar-color"></i>
                </button>
                <button @click="decreaseValue" class="down-btn">
                  <i class="pi pi-chevron-down ar-color"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-6 lg:col-6">
            <DropDownRequire
              :options="OptionsText"
              id="SiteId"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              v-model="selectedOption"
              editable
            ></DropDownRequire>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <span class="general-settings-text">
              {{ staticData.styling.colors }}
            </span>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-1"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="1"
              ref="colorPicker1"
            >
              <div class="border-box-color">
                <div
                  class="col-6 statictext"
                  v-tooltip="lmodel.setPageShareButtonToolTip"
                >
                  {{ lmodel.setPageShareButton }}
                </div>
                <div class="col-6 labeltext">
                  {{ vmodel1.minwidPopupButtonTextColor }}
                </div>
              </div>
              <span
                class="p-inputgroup-addon input-border"
                @click="toggleColorPicker(1)"
              >
                <span
                  id="minwidPopupButtonTextColor"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="
                    'background-color: ' + vmodel1.minwidPopupButtonTextColor
                  "
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[1]"
                v-model="vmodel1.minwidPopupButtonTextColor"
                @update:modelValue="
                  vmodel1.minwidPopupButtonTextColor =
                    vmodel1.minwidPopupButtonTextColor.hex8
                "
              />
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-2"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="2"
              ref="colorPicker2"
            >
              <div class="border-box-color">
                <div
                  class="col-6 statictext"
                  v-tooltip="lmodel.setMinwidPopupButtonBackgroundColorToolTip"
                >
                  {{ lmodel.setMinwidPopupButtonBackgroundColor }}
                </div>
                <div class="col-6 labeltext">
                  {{ vmodel1.minwidPopupButtonBackgroundColor }}
                </div>
              </div>
              <span
                class="p-inputgroup-addon input-border"
                @click="toggleColorPicker(2)"
              >
                <span
                  id="minwidPopupButtonTextColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="
                    'background-color: ' +
                    vmodel1.minwidPopupButtonBackgroundColor
                  "
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[2]"
                v-model="vmodel1.minwidPopupButtonBackgroundColor"
                @update:modelValue="
                  vmodel1.minwidPopupButtonBackgroundColor =
                    vmodel1.minwidPopupButtonBackgroundColor.hex8
                "
              />
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 lg:col-12">
            <div
              id="button-color-picker-3"
              class="p-inputgroup colorpicker-component colorpicker-element"
              data-colorpicker-id="3"
              ref="colorPicker3"
            >
              <div class="border-box-color">
                <div
                  class="col-6 statictext"
                  v-tooltip="lmodel.setWidgetShadowColorToolTip"
                >
                  {{ lmodel.setWidgetShadowColor }}
                </div>
                <div class="col-6 labeltext">
                  {{ vmodel1.setWidgetShadowColor }}
                </div>
              </div>
              <span
                class="p-inputgroup-addon input-border"
                @click="toggleColorPicker(3)"
              >
                <span
                  id="widgetShadowColorPicker"
                  class="p-colorpicker p-component p-colorpicker-overlay current-color"
                  :style="'background-color: ' + vmodel1.setWidgetShadowColor"
                ></span>
              </span>
              <Sketch
                v-if="colorPickerOpen[3]"
                v-model="vmodel1.setWidgetShadowColor"
                @update:modelValue="
                  vmodel1.setWidgetShadowColor =
                    vmodel1.setWidgetShadowColor.hex8
                "
              />
            </div>
          </div>
        </div>
      </TabPanel>

      <TabPanel header="Behaviour">
        <div class="grid col-12">
          <span class="general-settings-text">
            {{ staticData.behaviour.on_click }}
          </span>
        </div>
        <div class="grid">
          <div class="col-12">
            <DropDownRequire
              :options="Options"
              id="SiteId"
              placeholder="Go to maximized view"
              optionLabel="text"
              class="drop-down-val"
              optionValue="value"
              v-model="optionsSelect"
              editable
            ></DropDownRequire>
          </div>
        </div>

        <div class="grid" v-if="optionsSelect === 'redirectpage'">
          <div class="col-12">
            <label class="control-label">{{ lmodel.ambRedirectlanding }}</label>
            <InputRequiredText
              v-model="vmodel1.ambRedirectlanding"
              PropName="Redirect landing page instead of maximize"
              id="redirectlanding"
              type="text"
              autocomplete="off"
              class="mt-1"
            ></InputRequiredText>
          </div>
        </div>
      </TabPanel>
    </TabView>
    <!-- <div class="border-line mt-2"></div> -->
  </div>
</template>

<script>
import staticData from "@/staticdata/static.json";
import TabView from "primevue/tabview";
import { Cropper } from "vue-advanced-cropper";
import LabelTooltip from "@/components/shared/label-tooltip.vue";
import TabPanel from "primevue/tabpanel";
import { Sketch } from "@ckpack/vue-color";
// import moment from "moment";
import "vue-advanced-cropper/dist/style.css";

export default {
  components: {
    "label-tooltip": LabelTooltip,
    TabView,
    Sketch,
    Cropper,
    TabPanel,
  },
  props: {
    dealId: {
      type: String,
      default: null,
    },
    tabId: {
      type: Number,
      default: 0,
    },
    lmodel: {
      type: Object,
      default: null,
    },
    dmodel: {
      type: Object,
      default: null,
    },
    vmodel: {
      type: Object,
      default: null,
    },
    valmodel: {
      type: Object,
      default: null,
    },
    dealStatus: {
      type: Number,
      default: null,
    },
    isRedealText: {
      type: Boolean,
      default: false,
    },
    customerCampaignDealyDaysError: {
      type: String,
      default: null,
    },
    enableAmbassadorMailsAmb: {
      type: Boolean,
      default: false,
    },
    modelstate: {
      type: Object,
      default: null,
    },
    selectedDeviceType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      cropperIsActive: false,
      cropperIsActiveMinDesk: false,
      isValidCss: true,
      cssdata: "#fff",
      showInputs: false,
      value: "0px",
      valuepx: 0,
      isFloat: false,
      isEmb: false,
      imguploaded: false,
      selectcity2: "0",
      // ambcntdwn: false,
      cropperIsActiveMinWidMob: false,
      cropperIsActiveMaxWidMob: false,
      cropperIsActiveMaxWidDesk: false,
      cropperIsActiveMinWidDesk: false,
      widgetSelected: "floatcontent",
      selectedWidgetType: null,
      selectedImgType: null,
      imgurlval: "http://localhost:8080/img/abc.jpg",
      imageUp: "",
      imgurl: false,
      imgarchive: false,
      staticData: staticData.minimized,
      verticaloffset: "20",
      widgetlabelrwd: "Here is your 10% discount!",
      widgetlabel: "Signup now to get a 10% discount!",
      horizontaloffset: "10",
      displayimgwidget: false,
      positionPage: [
        { text: "Bottom left", value: "0" },
        { text: "Bottom right", value: "1" },
        { text: "Bottom center", value: "2" },
      ],
      Options: [
        { text: "Redirect landing page ", value: "redirectpage" },
        { text: "Maximize", value: "max" },
      ],
      selectedOptionText: "SR",
      selectedOption: "NR",
      OptionsText: [
        { text: "Normal", value: "NR" },
        { text: "Title", value: "TI" },
        { text: "SubTitle", value: "ST" },
      ],
      TextOptions: [
        { text: "Sora", value: "SR" },
        { text: "Voyado", value: "VY" },
      ],
      optionsSelect: "redirectpage",
      isImg: false,
      isText: false,
      computedheight: 500,
      computedwidth: 300,
      newheight: null,
      newwidth: null,
      computedheightmob: 164,
      computedwidthmob: 410,
      computedheightdesk: 164,
      computedwidthdesk: 410,
      mincomputedheightmob: 100,
      mincomputedwidthmob: 350,
      mincomputedheight: 100,
      mincomputedwidth: 350,
      newheightmob: null,
      newwidthmob: null,
      minnewheightmob: null,
      minnewwidthmob: null,
      minnewheightdesk: null,
      minnewwidthdesk: null,
      colorPickerOpen: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
      },
      uploadedSuccessfully: "Image uploaded successfully",
    };
  },
  computed: {
    vmodel1: {
      get() {
        return this.vmodel;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  mounted() {
    if (
      this.vmodel1.ambCusHeadMobMinExpImglogoPath !== "" ||
      this.vmodel1.ambCusHeadDeskMinExpImglogoPath !== ""
    ) {
      this.displayimgwidget = true;
      this.selectedImgType = "imgarchive";
    }

    document.body.style.overflow = "hidden";

    if (this.vmodel1.showMinWid == 1) {
      this.selectedWidgetType = "image";
      this.isImg = true;
    } else if (this.vmodel1.showMinWid == 0) {
      this.selectedWidgetType = "text";
      this.isText = true;
    }

    document.addEventListener("click", this.handleOutsideClick);

    if (this.vmodel1.showMinWid === 0) {
      this.vmodel1.mobMinWidimgstream = null;
      this.vmodel1.mobMinWidimgname = null;
      this.vmodel1.mobMinWidimgPath = null;
      this.vmodel1.deskMinWidimgstream = null;
      this.vmodel1.deskMinWidimgname = null;
      this.vmodel1.deskMinWidimgPath = null;
    }

    // this.showEmailval();
    // if (this.vmodel.ambdesktimgwdth > this.computedwidth) {
    //   this.newwidth = 300;
    // } else {
    //   this.newwidth = this.vmodel.ambdesktimgwdth;
    // }
    // if (this.vmodel.ambdesktimghght > this.computedheight) {
    //   this.newheight = 300;
    // } else {
    //   this.newheight = this.vmodel.ambdesktimghght;
    // }
    // if (this.vmodel.minMobimgwdth > this.computedwidthmob) {
    //   this.newwidthmob = 300;
    // } else {
    //   this.newwidthmob = this.vmodel.minMobimgwdth;
    // }
    // if (this.vmodel.ambmobimghght > this.computedheightmob) {
    //   this.newheightmob = 300;
    // } else {
    //   this.newheightmob = this.vmodel.ambmobimghght;
    // }

    if (this.vmodel.minMobimgwdth > this.mincomputedwidthmob) {
      this.minnewwidthmob = 300;
    } else {
      this.minnewwidthmob = this.vmodel.minMobimgwdth;
    }
    if (this.vmodel.minMobimghght > this.mincomputedheightmob) {
      this.minnewheightmob = 300;
    } else {
      this.minnewheightmob = this.vmodel.minMobimghght;
    }

    if (this.vmodel.minDesktimghght > this.mincomputedheight) {
      this.minnewheightdesk = 300;
    } else {
      this.minnewheightdesk = this.vmodel.minDesktimghght;
    }
    if (this.vmodel.minDesktimgwdth > this.mincomputedwidth) {
      this.minnewwidthdesk = 300;
    } else {
      this.minnewwidthdesk = this.vmodel.minDesktimgwdth;
    }
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleOutsideClick);
  },

  methods: {
    validateCssInput() {
      if (!/^(\.|#)/.test(this.cssdata)) {
        this.isValidCss = false;
      } else {
        this.isValidCss = true;
      }
    },
    increaseValue() {
      const numericValue = parseInt(this.value);
      if (numericValue < 100) {
        this.value = numericValue + 1 + "px";
      }
    },
    decreaseValue() {
      const numericValue = parseInt(this.value);
      if (numericValue > 0) {
        this.value = numericValue - 1 + "px";
      }
    },
    increaseValuePx() {
      if (this.valuepx < 100) {
        this.valuepx++;
      }
    },
    decreaseValuePx() {
      if (this.valuepx > 0) {
        this.valuepx--;
      }
    },
    toggleInputs() {
      this.showInputs = !this.showInputs;
    },
    clearImage() {
      this.imageUp = "";
      this.imguploaded = false;
      this.$refs.photo.clear();
    },
    selectWidgetDisplay(value) {
      this.widgetSelected = value;
      if (value === "floatcontent") {
        this.isFloat = true;
        this.isEmb = false;
      } else if (value === "embpage") {
        this.isEmb = true;
        this.isFloat = false;
      }
    },
    openFileUpload() {
      this.$refs.photo.choose();
    },

    onAdvancedUpload(fileObj) {
      var file = this.$refs.photo.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000,
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.imageUp = reader.result;
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000,
            });
          };
          image.src = reader.result;
          if (image.src) {
            this.imguploaded = true;
          }
        };
        reader.readAsDataURL(file);
      }
    },

    selectWidgetType(value) {
      this.selectedWidgetType = value;
      if (value === "text") {
        this.isText = true;
        this.isImg = false;
      } else if (value === "image") {
        this.isImg = true;
        this.isText = false;
      }
    },
    selectImgType(value) {
      this.selectedImgType = value;
      if (value === "imgurl") {
        this.imgurl = true;
        this.imgarchive = false;
      } else if (value === "imgarchive") {
        this.imgurl = false;
        this.imgarchive = true;
      }
    },
    activateCropper() {
      this.cropperIsActive = true;
    },
    closeCropper() {
      this.cropperIsActive = false;
    },
    captureCroppedImage() {
      const { canvas } = this.$refs.cropperComponent3.getResult();
      this.vmodel1.ambCusHeadMobMinExpImglogoPath = canvas.toDataURL();
      this.vmodel1.ambCusHeadMobMinExpImglogoStream = canvas.toDataURL();
      this.croppedImage = this.vmodel1.ambCusHeadMobMinExpImglogoPath;

      this.cropperIsActive = false;
    },

    //Image for Minimized Widget (Desktop)

    captureCroppedImageMinDesk() {
      const { canvas } = this.$refs.cropperComponent4.getResult();
      this.vmodel1.ambCusHeadDeskMinExpImglogoPath = canvas.toDataURL();
      this.vmodel1.ambCusHeadDeskMinExpImglogoStream = canvas.toDataURL();
      this.croppedImage = this.vmodel1.ambCusHeadDeskMinExpImglogoPath;

      this.cropperIsActiveMinDesk = false;
    },
    cropImageDesktopExp() {
      this.cropperIsActiveMinDesk = true;
    },
    closeCropperMinDesk() {
      this.cropperIsActiveMinDesk = false;
    },

    //Image in Image for Minimized Widget (Mobile)

    captureCroppedImageMinWidMob() {
      const { canvas } = this.$refs.cropperComponent1.getResult();
      this.vmodel1.mobMinWidimgPath = canvas.toDataURL();
      this.vmodel1.mobMinWidimgstream = canvas.toDataURL();
      this.croppedImage = this.vmodel1.mobMinWidimgPath;

      this.cropperIsActiveMinWidMob = false;
    },
    cropImageimgminMob() {
      this.cropperIsActiveMinWidMob = true;
    },
    closeCropperMinWidMob() {
      this.cropperIsActiveMinWidMob = false;
    },

    //Image in Image for Minimized Widget (Desktop)

    captureCroppedImageMinWidDesk() {
      const { canvas } = this.$refs.cropperComponent4.getResult();
      this.vmodel1.deskMinWidimgPath = canvas.toDataURL();
      this.vmodel1.deskMinWidimgstream = canvas.toDataURL();
      this.croppedImage = this.vmodel1.deskMinWidimgPath;

      this.cropperIsActiveMinWidDesk = false;
    },
    cropImageimgminDesk() {
      this.cropperIsActiveMinWidDesk = true;
    },
    closeCropperMinWidDesk() {
      this.cropperIsActiveMinWidDesk = false;
    },

    toggleColorPicker(id) {
      // Toggle the state of color picker
      this.colorPickerOpen[id] = !this.colorPickerOpen[id];

      // Close other color pickers when one is opened
      for (let key in this.colorPickerOpen) {
        if (key != id) {
          this.colorPickerOpen[key] = false;
        }
      }
    },

    handleOutsideClick(event) {
      for (let key in this.$refs) {
        if (key.startsWith("colorPicker")) {
          if (!this.$refs[key].contains(event.target)) {
            const id = parseInt(key.replace("colorPicker", ""), 10);
            this.colorPickerOpen[id] = false;
          }
        }
      }
    },

    addHashPrefix() {
      if (
        this.vmodel1.minwidPopupButtonTextColor &&
        !this.vmodel1.minwidPopupButtonTextColor.startsWith("#")
      ) {
        this.vmodel1.minwidPopupButtonTextColor =
          "#" + this.vmodel1.minwidPopupButtonTextColor.toUpperCase();
      } else if (
        this.vmodel1.minwidPopupButtonBackgroundColor &&
        !this.vmodel1.minwidPopupButtonBackgroundColor.startsWith("#")
      ) {
        this.vmodel1.minwidPopupButtonBackgroundColor =
          "#" + this.vmodel1.minwidPopupButtonBackgroundColor.toUpperCase();
      } else if (
        this.vmodel1.setWidgetShadowColor &&
        !this.vmodel1.setWidgetShadowColor.startsWith("#")
      ) {
        this.vmodel1.setWidgetShadowColor =
          "#" + this.vmodel1.setWidgetShadowColor.toUpperCase();
      } else {
        this.vmodel1.minwidPopupButtonTextColor =
          this.vmodel1.minwidPopupButtonTextColor.toUpperCase();
        this.vmodel1.minwidPopupButtonBackgroundColor =
          this.vmodel1.minwidPopupButtonBackgroundColor.toUpperCase();
        this.vmodel1.setWidgetShadowColor =
          this.vmodel1.setWidgetShadowColor.toUpperCase();
      }
    },
    handleImgminMob(fileObj) {
      var file = this.$refs.fileImgminMob.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000,
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.mobMinWidimgstream = reader.result;
            this.vmodel1.mobMinWidimgname = file.name;
            this.vmodel1.mobMinWidimgPath = reader.result;
            this.vmodel1.minMobimghght = image.height;
            this.vmodel1.minMobimgwdth = image.width;
            if (this.vmodel1.minMobimgwdth > this.mincomputedwidthmob) {
              this.minnewwidthmob = 300;
            } else {
              this.minnewwidthmob = this.vmodel1.minMobimgwdth;
            }
            if (this.vmodel1.minMobimghght > this.mincomputedheightmob) {
              this.minnewheightmob = 300;
            } else {
              this.minnewheightmob = this.vmodel1.minMobimghght;
            }
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000,
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    openFileUploadImgminMob() {
      this.$refs.fileImgminMob.choose();
    },
    replaceFileImgminMob() {
      this.$refs.fileImgminMob.clear();
      this.$refs.fileImgminMob.choose();
    },
    clearImageimgminMob() {
      this.$refs.fileImgminMob.clear();
      this.vmodel1.mobMinWidimgstream = null;
      this.vmodel1.mobMinWidimgname = null;
      this.vmodel1.mobMinWidimgPath = null;
    },

    handleImgminDesktop(fileObj) {
      var file = this.$refs.fileImgminDesk.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000,
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.deskMinWidimgstream = reader.result;
            this.vmodel1.deskMinWidimgname = file.name;
            this.vmodel1.deskMinWidimgPath = reader.result;
            this.vmodel1.minDesktimghght = image.height;

            this.vmodel1.minDesktimgwdth = image.width;

            if (this.vmodel1.minDesktimgwdth > this.mincomputedwidth) {
              this.minnewwidthdesk = 300;
            } else {
              this.minnewwidthdesk = this.vmodel1.minDesktimgwdth;
            }
            if (this.vmodel1.minDesktimghght > this.mincomputedheight) {
              this.minnewheightdesk = 300;
            } else {
              this.minnewheightdesk = this.vmodel1.minDesktimghght;
            }
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000,
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    openFileUploadImgminDesk() {
      this.$refs.fileImgminDesk.choose();
    },
    replaceFileImgminDesk() {
      this.$refs.fileImgminDesk.clear();
      this.$refs.fileImgminDesk.choose();
    },
    clearImageimgminDesk() {
      this.$refs.fileImgminDesk.clear();
      this.vmodel1.deskMinWidimgstream = null;
      this.vmodel1.deskMinWidimgname = null;
      this.vmodel1.deskMinWidimgPath = null;
    },

    openFileUploadMobileExp() {
      this.$refs.filemobileexp.choose();
    },
    handleFileUploadExpandMob(fileObj) {
      var file = this.$refs.filemobileexp.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000,
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.ambCusHeadMobMinExpImglogoStream = reader.result;
            this.vmodel1.ambCusHeadMobMinExpImgactualFileName = file.name;
            this.vmodel1.ambCusHeadMobMinExpImglogoPath = reader.result;
            // this.vmodel1.mobtimghght = image.height;
            // this.vmodel1.mobtimgwdth = image.width;
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000,
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    replaceFileMobileExp() {
      this.$refs.filemobileexp.clear();
      this.$refs.filemobileexp.choose();
    },
    clearImageMobileExp() {
      this.$refs.filemobileexp.clear();
      this.vmodel1.ambCusHeadMobMinExpImglogoStream = null;
      this.vmodel1.ambCusHeadMobMinExpImgactualFileName = null;
      this.vmodel1.ambCusHeadMobMinExpImglogoPath = null;
    },
    // test() {
    //   if (this.vmodel1.customerIsTimeSpanCoupon == false) {
    //     this.customerTimeSpanDaysAmount2 =
    //       this.vmodel1.customerTimeSpanDaysAmount;
    //     this.vmodel1.customerTimeSpanDaysAmount = 0;
    //   } else if (this.vmodel1.customerIsTimeSpanCoupon == true) {
    //     this.vmodel1.customerTimeSpanDaysAmount =
    //       this.customerTimeSpanDaysAmount2;
    //   }
    // },

    handleFileUpload(fileObj) {
      var file = this.$refs.filemobile.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000,
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.mobHeaderimagestream = reader.result;
            this.vmodel1.mobHeaderimagename = file.name;
            this.vmodel1.mobHeaderimagepath = reader.result;
            this.vmodel1.mobimghght = image.height;
            this.vmodel1.mobimgwdth = image.width;
            if (this.vmodel1.mobimgwdth > this.computedwidthmob) {
              this.newwidthmob = 300;
            } else {
              this.newwidthmob = this.vmodel1.mobimgwdth;
            }
            if (this.vmodel1.mobimghght > this.computedheightmob) {
              this.newheightmob = 300;
            } else {
              this.newheightmob = this.vmodel1.mobimghght;
            }
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000,
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    openFileUploadMobile() {
      this.$refs.filemobile.choose();
    },
    replaceFileMobile() {
      this.$refs.filemobile.clear();
      this.$refs.filemobile.choose();
    },
    clearImageMobile() {
      this.$refs.filemobile.clear();
      this.vmodel1.mobHeaderimagestream = null;
      this.vmodel1.mobHeaderimagename = null;
      this.vmodel1.mobHeaderimagepath = null;
      this.vmodel1.mobimghght = 0;
      this.vmodel1.mobimgwdth = 0;
    },

    handleFileUploadDesktop(fileObj) {
      var file = this.$refs.filedesktop.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000,
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.headerimagestream = reader.result;
            this.vmodel1.headerimagename = file.name;
            this.vmodel1.headerimagepath = reader.result;
            this.vmodel1.desktimghght = image.height;
            this.vmodel1.desktimgwdth = image.width;
            if (this.vmodel1.desktimgwdth > this.computedwidth) {
              this.newwidth = 300;
            } else {
              this.newwidth = this.vmodel1.desktimgwdth;
            }
            if (this.vmodel1.desktimghght > this.computedheight) {
              this.newheight = 300;
            } else {
              this.newheight = this.vmodel1.desktimghght;
            }
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000,
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    openFileUploadDesktop() {
      this.$refs.filedesktop.choose();
    },
    replaceFileDesktop() {
      this.$refs.filedesktop.clear();
      this.$refs.filedesktop.choose();
    },
    clearImageDesktop() {
      this.$refs.filedesktop.clear();
      this.vmodel1.headerimagestream = null;
      this.vmodel1.headerimagename = null;
      this.vmodel1.headerimagepath = null;
      this.vmodel1.desktimgwdth = 0;
      this.vmodel1.desktimghght = 0;
    },

    openFileUploadDesktopExp() {
      this.$refs.filedesktopexp.choose();
    },
    handleFileUploadDesktopExp(fileObj) {
      var file = this.$refs.filedesktopexp.files[0];
      if (
        !fileObj ||
        (fileObj && !fileObj.files) ||
        (fileObj && fileObj.files && fileObj.files.length === 0)
      ) {
        this.$toast.add({
          severity: "error",
          summary: "Error",
          detail: this.unsupportedFileTypeMsg,
          life: 3000,
        });
        this.$refs.file.clear();
      } else {
        let reader = new FileReader();
        reader.onload = () => {
          var image = new Image();
          image.onload = () => {
            this.vmodel1.ambCusHeadDeskMinExpImglogoStream = reader.result;
            this.vmodel1.ambCusHeadDeskMinExpImgactualFileName = file.name;
            this.vmodel1.ambCusHeadDeskMinExpImglogoPath = reader.result;
            this.vmodel1.desktimghght = image.height;
            this.vmodel1.desktimgwdth = image.width;
            this.$toast.add({
              severity: "success",
              summary: "Success",
              detail: this.uploadedSuccessfully,
              life: 3000,
            });
          };
          image.src = reader.result;
        };
        reader.readAsDataURL(file);
      }
    },
    replaceFileDesktopExp() {
      this.$refs.filedesktopexp.clear();
      this.$refs.filedesktopexp.choose();
    },
    clearImageDesktopExp() {
      this.$refs.filedesktopexp.clear();
      this.vmodel1.ambCusHeadDeskMinExpImglogoStream = null;
      this.vmodel1.ambCusHeadDeskMinExpImgactualFileName = null;
      this.vmodel1.ambCusHeadDeskMinExpImglogoPath = null;
      this.vmodel1.ambCusHeadDeskMinExpImglogoName = null;
    },

    handleFontFile(event) {
      const selectedFiles = event.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        const reader = new FileReader();
        reader.onload = () => {
          this.vmodel1.popupFontFileStream = reader.result;
          this.vmodel1.popupSelectedFont = selectedFiles[i].name;
          // this.vmodel1.popupFontName = selectedFiles[i].name;
        };
        reader.readAsDataURL(selectedFiles[i]);
      }
    },
    handleTitleFontFile(event) {
      const selectedFiles = event.files;
      for (let i = 0; i < selectedFiles.length; i++) {
        const reader = new FileReader();
        reader.onload = () => {
          this.vmodel1.popupTitleFontFileStream = reader.result;
          this.vmodel1.popupTitleFontName = selectedFiles[i].name;
        };
        reader.readAsDataURL(selectedFiles[i]);
      }
    },
    onCopy: function () {
      this.copySucceeded = true;
    },

    onError: function () {
      this.copySucceeded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
input:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}
.p-inputtext:enabled:focus {
  outline: 0 none !important;
  outline-offset: 0 !important;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

:deep(.p-chips:not(.p-disabled).p-focus .p-chips-multiple-container) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
  border: #c0c0bc !important;
  outline: 2px solid #222222 !important;
  border-style: double !important;
}

.p-chips .p-chips-multiple-container .p-chips-input-token input {
  font-size: 1rem;
  color: #212529;
  padding: 0;
  margin: 0;
  width: 370px;
}

.p-calendar {
  position: relative;
  display: inline-flex;
  width: 395px;
}
input {
  color: #777 !important;
  font-size: 0.8rem;
  height: calc(1.5em + 0.75rem + 7px);
  width: 100%;
  box-shadow: none;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext) {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  // border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
:deep(.p-inputtext:enabled:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none;
  // border: 1px solid #cedacf;
}

.checkbox-radio-font {
  font-size: 14px;
}
h4 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 0;
  font-size: 1.5rem;
}
h6 {
  font-size: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  margin-top: 0;
}
.control-label {
  font-size: 1rem;
  padding-bottom: 3px;
  display: block !important;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: normal;
  position: relative;
  vertical-align: top;
}
.control-label1 {
  font-size: 1rem;
  padding-bottom: 3px;
  display: block !important;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: bold;
  position: relative;
  vertical-align: top;
}
hr {
  margin: 20px 0;
  border: 0;
  border-top: 1px solid #e0dfdf;
  border-bottom: 1px solid #fefefe;
}
.square-box {
  width: 300px;
  position: relative;
  overflow: hidden;
}
.square-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
:deep(.p-chips .p-chips-multiple-container .p-chips-input-token input) {
  padding: 20px;
  margin: 0;
  padding-top: 1px;
  padding-left: inherit;
}

h5 {
  font-size: 18px;
  font-family: "Voyado Text";
  margin-bottom: 0.5rem;
  font-weight: bold;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 0.5rem;
}
.box-size {
  width: 390px;
}
.custom-settings {
  margin-top: 30px;
}
.custom-settings-button {
  font-size: 20px;
  font-weight: 400;
  line-height: 17.1px;
  text-align: left;
}
.no-border {
  color: #777777;
  border: #797971 !important;
  background: none !important;
  padding: 0;
  margin-left: 10px;
  font-size: 33px;
}
.bib {
  font-size: 1.3em;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.copytooltip .tooltiptext {
  visibility: hidden;
  width: auto !important;
  background-color: #f38672;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -75px;
  opacity: 0;
  transition: opacity 0.3s;
}
.copytooltip {
  position: relative;
  display: inline-block;
  top: 0px;
  left: 10px;
}
.copytooltip i {
  font-size: 22px;
  cursor: pointer;
}
.copytooltip .tooltiptext {
  visibility: hidden;
  width: 140px;
  background-color: #f38672;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -75px;
  opacity: 0;
  transition: opacity 0.3s;
}
.copytooltip .tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #f38672 transparent transparent transparent;
}
.copytooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

.box-size {
  width: 420px;
}

.fa-toggle-on {
  font-size: 2.25em;
  color: #43a584 !important;
}

.fa-toggle-off {
  font-size: 2.25em;
  color: #d8d8d5 !important;
}
:deep(.textareaBody) {
  height: 90px !important;
  .p-inputtextarea {
    height: 90px !important;
  }
}
.header-container {
  height: 120px;
  padding: 26px 40px 26px 40px;
  gap: 0px;
  border-radius: 4px 4px 0px 0px;
  opacity: 0px;
}
.small-text {
  font-family: Voyado Text;
  font-size: 14.22px;
  font-weight: 400;
  line-height: 17.07px;
  text-align: left;
}
:deep(.card-header) {
  height: 53px;
  border-color: #eff2f7;
  background: #fff;
  font-size: 16px;
  font-weight: 500 !important;
  padding: 0.75rem 1.25rem;
  border-bottom: none;
}
.header-text {
  display: flex;
  align-items: center;
  height: 120px;
  padding: 26px 40px 26px 40px;
  border-radius: 4px 4px 0px 0px;
  // background-color: #efefef;
}

.header-text h5 {
  margin: 0;
}

.small-text {
  margin-left: 20px;
}
.header-text span {
  display: block;
  margin-top: 5px;
}

//New css-ry
.line-text {
  align-items: center;
  padding: 0px 42px 0px 32px !important;
  // justify-content: space-between;
  // display: flex;
}
.line-text-2 {
  align-items: center;
  padding: 0px 32px 15px 32px;
}
:deep(.p-dropdown) {
  height: 40px;
  width: 395px;
  line-height: 1.5;
  font-size: 14px !important;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  color: #c0c0bc !important;
  text-decoration: none;
  box-shadow: none;
  background: none;
  justify-content: space-between;
}

:deep(input) {
  height: 40px;
  width: 395px;
  border-radius: 4px;
  border: 1px solid #c0c0bc;
  padding: 10px;
}

//new css-v

.toggle-button {
  display: flex;
  align-items: center;
  margin-left: 5px;
}
.toggle-button span {
  cursor: pointer;
  vertical-align: middle; /* Add this line */
}
.general-settings {
  margin-top: 10px;
  display: flex;
  align-items: center;
}
.general-settings-text {
  font-size: 14.22px !important;
  font-weight: 500 !important;
  line-height: 17.1px !important;
  color: #21211f !important;
  // text-align: left;
}
.toggleblock-btn {
  font-size: 15px;
  font-weight: 400;
  cursor: pointer;
}
.button-container {
  padding: 26px 40px 26px 40px;
}
.border-line {
  border-top: 1px solid #e5e5e5;
}
:deep(.text-right) {
  text-align: right !important;
}
.show-all {
  background-color: white !important;
  border: 2px solid #e0e9e8 !important;
  width: auto !important;
  padding: 0px 8px 0px 8px;
  height: 24px !important;
  border-radius: 4px !important;
  line-height: 15px !important;
  color: #2d6e6d !important;
  font-weight: 500 !important;
}
.edit-btn[disabled] {
  background-color: #efefef;
  font-weight: 400;
  color: black;
  cursor: not-allowed !important;
  border-color: #efefef;
}

.settings-header {
  background-color: #2d6e6d !important;
}
.border-box {
  border: 1px solid #c0c0bc;
  height: 40px;
  display: flex;
  border-radius: 4px;
  width: 100%;
  text-align: center;
  //   justify-content: center;
}

:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link:not(.p-disabled):focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link) {
  border: none !important;
  background: #ffffff;
  color: #000000;
  padding: 1rem 1.125rem 0rem;
  font-weight: 400;
  font-size: 14.22px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  transition: background-color 0.2s, color 0.2s, border-color 0.2s,
    box-shadow 0.2s, outline-color 0.2s;
  margin: 0 0 -1px 0;
  outline-color: transparent;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link) {
  background: #ffffff;
  // border-color: #dee2e6 !important;
  border: 1px solid #dee2e6 !important;
  border-width: 0px 0px 1px 0px !important;
  color: #000000;
  font-weight: 400;
  font-size: 14.22px;
  line-height: 17.1px;
}
:deep(.p-tabview .p-tabview-nav li .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border: none;
}
:deep(.p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link span) {
  padding-bottom: 1rem;
  border-bottom: 3px solid #791a3f;
}
:deep(.p-tabview .p-tabview-ink-bar) {
  display: none !important;
}

.drop-down-val {
  height: 40px !important;
  line-height: 1.5;
  font-size: 14px !important;
  background-color: #ffffff !important;
  text-decoration: none !important;
  box-shadow: none !important;
}
.imagefit {
  margin-top: 5px;
  width: 500px;
  height: 500px;
  overflow: hidden;
  position: relative;
  max-width: 100%;
  max-height: 100%;
}

.upload-text {
  width: 100%;
  height: 24px;
  // font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #000000;
  flex: none;
  order: 0;
  flex-grow: 0;
}
.upload-text-small {
  width: 158px;
  height: 20px;
  font-weight: 500;
  font-size: 14.22px;
  line-height: 20px;
  margin-top: -8px;
  color: #87838f;
  flex: none;
  order: 1;
  flex-grow: 0;
}
:deep(.p-button:focus) {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: none !important;
}

//grecy
.input-wrapper {
  position: relative;
}
.input-wrapper button {
  position: absolute;
  right: 7%;
  width: 2px;
  top: 45%;
  transform: translateY(-50%);
  padding: 0 10px;
  background-color: #fff;
  border: none;
  font-family: "Voyado Text";
  color: #909090;
}
.input-wrapper button:hover {
  background-color: #fff;
}
:deep(.input-wrapper input:focus) {
  outline: 1px solid black;
  border-radius: 4px;
  outline: none;
}
.input-num {
  position: relative;
  width: 100%;
  display: flex;
}
.input-num input {
  flex: 1;
}
:deep(
    .p-inputnumber-buttons-stacked
      .p-inputnumber-button-group
      .p-button.p-inputnumber-button
  ) {
  background-color: #ffffff !important;
  color: #797971 !important;
  border-color: #c0c0bc !important;
}
.p-colorpicker-preview {
  width: 25px !important;
  height: 25px;
}
.p-colorpicker-preview {
  width: 25px !important;
  height: 25px;
}
.p-inputgroup-addon {
  background: #fff !important;
  color: #495057;
  border-top: 1px solid #c0c0bc;
  // border-left: none;
  border-bottom: 1px solid #c0c0bc;
  padding: 0.5rem 0.75rem;
  /* min-width: 2.357rem; */
  // width: 100%;
  height: 40px;
  // border-top-left-radius: 0px !important;
  // border-bottom-left-radius: 0px !important;
  border-right: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.p-inputgroup-add {
  background: #fff !important;
  color: #495057;
  border-bottom: 1px solid #c0c0bc;
  border-top: 1px solid #c0c0bc;
  border-left: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  height: 40px;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.input-group-append {
  margin-left: -1px;
}
.p-inputgroup > .p-inputwrapper:last-child > .p-inputtext {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.p-inputgroup > input:first-child {
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px;
  border-right: none;
}
.colorpicker-component {
  position: relative;
}
.vc-sketch {
  position: absolute !important;
  z-index: 1 !important;
  right: 0 !important;
  top: 40px !important;
  width: 200px;
  padding: 10px 10px 0;
  box-sizing: initial;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.15), 0 8px 16px rgba(0, 0, 0, 0.15);
}
.current-color {
  display: inline-block;
  width: 28px;
  height: 28px;
  background-color: #000;
  cursor: pointer;
  border: 1px solid #c0c0bc;
  border-radius: 8px;
}

/* Style for the input field */
.colorpicker-input {
  width: 376px !important;
  height: 40px !important;
  padding: 6px 12px;
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
  position: relative;
}
.p-inputtextcolor {
  color: #21211f !important;
  font-size: 16px;
  width: 100%;
  box-shadow: none;
  border-radius: 0.25rem;
  font-weight: 400;
  line-height: 1;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text";
}
.p-inputtextcolor::before {
  content: "Shadow color ";
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: black;
}

.p-inputtextcolor::after {
  content: attr(value);
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  color: black;
}

.p-inputgroup > .p-inputwrapper:last-child > .p-inputtextcolor {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.color-pick {
  border-color: #e9ecef;
  width: 16px;
  height: 16px !important;
}
.input-border {
  border-top-left-radius: 0px !important;
  border-left: none !important;
  border-bottom-left-radius: 0px !important;
}
.float {
  float: right;
}

.border-box-color {
  border: 1px solid #c0c0bc;
  height: 40px;
  display: flex;
  width: 100%;
  text-align: center;
  border-right: none !important;
  border-top-left-radius: 4px !important;
  border-bottom-left-radius: 4px !important;
}

.statictext {
  justify-content: left;
  display: flex;
  color: #21211f;
  font-family: "Voyado Text";
}

.labeltext {
  justify-content: right;
  display: flex;
  color: #21211f;
  font-family: "Voyado Text";
}
:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
  background: #ffffff;
  border: 0 none;
  color: #212529;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}

.setting-layout {
  margin-top: 180px;
  font-family: "Voyado Text" !important;
}
:deep(.setting-layout.p-tabview .p-tabview-panels) {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: calc(100vh - 260px);
}

.p-inputgroup-addon-radius {
  background: #9b1c45;
  color: #495057;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  padding: 0.5rem 0.75rem;
  height: 40px;
  border-right: 1px solid #c0c0bc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.container-spacing {
  margin-top: 24px;
}
:deep(.p-tabview .p-tabview-panels) {
  padding: 16px !important;
}
.hrs-btn {
  border: none;
  height: 40px !important;
  background-color: #fff;
  border-top: 1px solid #c0c0bc;
  border-bottom: 1px solid #c0c0bc;
  color: #797971;
  cursor: text;
}

.down-btn {
  border: 1px solid #c0c0bc;
  background-color: #fff;
  height: 20px;
  width: 30px;
  display: grid;
  border-bottom-right-radius: 4px;
}

.up-btn {
  border: 1px solid #c0c0bc;
  background-color: #fff;
  height: 20px;
  width: 30px;
  display: grid;
  border-top-right-radius: 4px;
}
.ar-color {
  color: #797971 !important;
}

.border-icon {
  border-right: none;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;
}

//For Test
:deep(.p-inputtext, input) {
  width: 100%;
  box-shadow: none;
  font-weight: 400;
  padding: 0.375rem 0.75rem;
  font-family: "Voyado Text" !important;
}

:deep(.control-label) {
  font-size: 14px;
  padding-bottom: 3px;
  display: inline-block;
  margin-bottom: 0px;
  padding-top: 7px;
  font-weight: normal;
  position: relative;
  vertical-align: top;
  color: #21211f;
  font-family: "Voyado Text";
}

.photo-section span {
  margin-top: 8px;
  text-align: center;
}

:deep(.p-button .p-button-icon-left) {
  margin-right: 0rem;
}
</style>
